import { render, staticRenderFns } from "./HubTable.vue?vue&type=template&id=5d69d94b&"
import script from "./HubTable.vue?vue&type=script&lang=js&"
export * from "./HubTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports